import { faLock } from "@fortawesome/free-solid-svg-icons/faLock"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"

import { TEST_IDS } from "~config/constants"

export default function LockedFeatureIcon({
    size,
    style = {},
}: {
    readonly size?: number
    readonly style?: React.CSSProperties
}) {
    return (
        <FontAwesomeIcon
            data-testid={TEST_IDS.LOCK_ICON}
            style={style}
            icon={faLock}
            fontSize={size}
        />
    )
}
